// src/components/common/Unauthorized.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        textAlign: 'center',
        marginTop: '80px',
        padding: '20px',
      }}
    >
      <h2>🚫 Access Denied</h2>
      <p>You don't have permission to view this page.</p>
      <button
        onClick={() => navigate('/dashboard')}
        style={{
          marginTop: '16px',
          padding: '10px 20px',
          cursor: 'pointer',
        }}
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default Unauthorized;
